import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const SectionCard = ({ icon: Icon, title, description, actions, children }) => (
  <Paper
    variant="outlined"
    sx={{
      p: { xs: 2, sm: 2.5 },
      borderRadius: 2,
      mb: { xs: 2, sm: 2.5 },
      borderColor: "#e5e5e5",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        mb: 2,
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {Icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              borderRadius: "50%",
              backgroundColor: "rgba(31, 27, 69, 0.08)",
              color: "#1F1B45",
              flexShrink: 0,
            }}
          >
            <Icon fontSize="small" />
          </Box>
        )}
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: { xs: "0.95rem", sm: "1.05rem" } }}>
            {title}
          </Typography>
          {description && (
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {description}
            </Typography>
          )}
        </Box>
      </Box>
      {actions}
    </Box>
    {children}
  </Paper>
);

export default SectionCard;
